import { RootState } from '@reducers';

export const selectFeatureCollaboration = (state: RootState) => state.featureReducer.collaborationReducer;
